import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'app/auth/JwtService';
import { ModaleComponent } from 'app/generic/modale/modale.component';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HeaderService extends JwtService {

  constructor(private http: HttpClient,
              public router: Router,
              public modalComponent: ModaleComponent) { super(router, modalComponent); }

  getAllNotifiche(): Promise<any> {

    return this.http.get(environment.APIendpoint + '/ApplicativiRest/rest/ricerca-terza-missione/listAllNotificheProgettiByUserDestinatarioPaged?pageNumber=1&pageMaxElement=99',).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }

  cambiaStatoNotificheProgetti(request: any): Promise<any> {

    return this.http.post(environment.APIendpoint + '/ApplicativiRest/rest/ricerca-terza-missione/cambiaStatoNotificheProgetti', request).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }

  deleteListNotificheProgettiById(request): Promise<any> {
    return this.http.post(environment.APIendpoint + '/ApplicativiRest/rest/ricerca-terza-missione/deleteListNotificheProgettiById', request).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  deleteNotificheProgettiByExtUserIdDestinatario(): Promise<any> {
    return this.http.delete(environment.APIendpoint + '/ApplicativiRest/rest/ricerca-terza-missione/deleteNotificheProgettiByExtUserIdDestinatario', ).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }
}
